'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useMutationObserver = require('./use-mutation-observer.js');

/**
 * React hook for detecting if `dir="rtl"` is present on an `HTMLElement` or `ref`.
 * Defaults to `<html>` element as `node`.
 * @params UseRtlOptions
 * @returns UseRtlState
 */ const useRtl = (options = {})=>{
    const { ref , node =ref ? undefined : document.querySelectorAll('html')[0]  } = options;
    const [isRtl, setIsRtl] = React.useState(false);
    useMutationObserver.useMutationObserver({
        callback: (mutations)=>{
            for (const mutation of mutations){
                const { attributeName , target , type  } = mutation;
                if (attributeName === 'dir' && type === 'attributes') {
                    setIsRtl(target.dir === 'rtl' ? true : false);
                }
            }
        },
        mutationObserverOptions: {
            attributes: true
        },
        node: ref ? undefined : node,
        ref
    });
    React.useEffect(()=>{
        if (node) {
            setIsRtl(node.dir === 'rtl');
        }
    }, [
        node
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (ref?.current) {
            setIsRtl(ref?.current.dir === 'rtl');
        }
    }, [
        ref?.current
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        dir: isRtl ? 'rtl' : 'ltr',
        isRtl
    };
};

exports.useRtl = useRtl;
//# sourceMappingURL=use-rtl.js.map
